import { render, staticRenderFns } from "./StatusDuration.vue?vue&type=template&id=43951441&scoped=true"
import script from "./StatusDuration.vue?vue&type=script&lang=js"
export * from "./StatusDuration.vue?vue&type=script&lang=js"
import style0 from "./StatusDuration.vue?vue&type=style&index=0&id=43951441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43951441",
  null
  
)

export default component.exports